import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ArticleOptionGroupFlavorComponent} from '../components/article-option-group-flavor/article-option-group-flavor.component';
import {ItemSelectableArticleComponent} from '../components/item-selectable-article/item-selectable-article.component';
import {ToOrderButtonComponent} from '../components/to-order-button/to-order-button.component';
import {OrderListComponent} from '../components/order-list/order-list.component';
import {ToggleButtonGroupComponent} from '../components/toggle-button-group/toggle-button-group.component';
import {MenuPopoverComponent} from '../components/menu-popover/menu-popover.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MyOrderComponent} from '../components/my-order/my-order.component';
import {QRCodeModule} from 'angularx-qrcode';
import {ItemViewComponent} from '../components/item-view/item-view.component';
import {ArticleOptionGroupSingleComponent} from '../components/article-option-group-single/article-option-group-single.component';
import {VenueSuggestionComponent} from '../components/venue-suggestion/venue-suggestion.component';
import {HomePopoverComponent} from '../components/home-popover/home-popover.component';
import {ArticleOptionGroupCheckboxComponent} from '../components/article-option-group-checkbox/article-option-group-checkbox.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {createTranslateLoader} from '../app.module';
import {BurgerBtnComponent} from '../components/burger-btn/burger-btn.component';
import {ArticleOptionGroupMultipleComponent} from '../components/article-option-group-multiple/article-option-group-multiple.component';
import {RouterModule} from '@angular/router';
import {OrderContentComponent} from '../components/order-content/order-content.component';
import {VitalCodeComponent} from '../components/vital-code/vital-code.component';
import {PaymentMethodsDisplayComponent} from '../components/payment-methods-display/payment-methods-display.component';
import {CustomAddressModalComponent} from '../components/custom-address-modal/custom-address-modal.component';
import {TipComponent} from '../components/tip/tip.component';
import {LangStringPipe} from '../../smoothr-web-app-core/pipes/lang-string.pipe';
import {TagComponent} from '../components/tag/tag.component';
import {QuantitySelectorComponent} from '../components/quantity-selector/quantity-selector.component';
import {PreorderTypeChipComponent} from '../components/preorder-type-chip/preorder-type-chip.component';
import {AccountToolbarComponent} from '../components/account-toolbar/account-toolbar.component';
import {SlotsSelectorComponent} from '../components/slots-selector/slots-selector.component';
import {MenuModalComponent} from '../components/menu-modal/menu-modal.component';
import {NoteArticleModalComponent} from '../components/note-article-modal/note-article-modal.component';
import {LangObservablePipe} from '../../smoothr-web-app-core/pipes/lang-obervable.pipe';
import {AppRestorePasswordModalComponent} from '../components/app-restore-password-modal/app-restore-password-modal.component';
import {SelectDateFormcontrolComponent} from '../components/select-date-formcontrol/select-date-formcontrol.component';
import {CheckDeliveryRadiusModalComponent} from '../components/check-delivery-radius-modal/check-delivery-radius-modal.component';
import {MapVenueComponent} from 'src/maps/components/map-venue/map-venue.component';
import {ToolbarLogoComponent} from '../components/toolbar-logo/toolbar-logo.component';
import {FiltersMenuComponent} from '../components/filters-menu/filters-menu.component';
import {AccordionListComponent} from '../components/accordion-list/accordion-list.component';
import {ArticleOptionGroupToggleComponent} from '../components/article-option-group-toggle/article-option-group-toggle.component';
import {CheckoutComponent} from '../components/checkout-component/checkout.component';
import {GetAddressModalComponent} from '../components/get-address-modal/get-address-modal.component';
import {FavouriteModalOnAddComponent} from '../components/favourite-modal-on-add/favourite-modal-on-add.component';
import {ScanQrModal} from '../components/scan-qr/scan-qr.component';
import {ZXingScannerModule} from 'src/scanner/public_api';
import {SelectTableModalComponent} from '../components/select-table-modal/select-table-modal.component';
import {FirstBoldPipe} from '../pipes/transform-text.pipe';
import {FilterMapComponent} from 'src/maps/components/filter-map/filter-map.component';
import {MatRadioModule} from '@angular/material/radio';
import {ShowVenueInMapComponent} from '../components/show-venue-in-map/show-venue-in-map.component';
import {SelectTableCheckoutComponent} from '../components/select-table-checkout/select-table-checkout.component';
import {VitalcodeComponent} from '../components/vitalcode/vitalcode.component';
import {ShowOrderItemComponent} from '../components/show-order-item/show-order-item.component';
import {FirstThinPipe} from '../pipes/transform-text-first-thin';
import {LastLetterThinPipe} from '../pipes/transform-text-last-thin';
import {SlotsModalComponent} from '../components/slots-modal/slots-modal.component';
import {SubscriptionComponent} from '../components/subscription/subscription.component';
import {AlertDeleteSubscriptionComponent} from '../components/alert-delete-subscription/alert-delete-subscription.component';
import {OrderSubscriptionItemComponent} from '../components/order-subscription-item/order-subscription-item.component';
import {AlertInfoModalComponent} from '../components/alert-info-modal/alert-info-modal.component';
import {ShowQrComponent} from '../components/show-qr/show-qr.component';
import {ShowSocialLinksComponent} from '../components/show-social-links/show-social-links.component';
import {InfoModalSecondViewComponent} from '../components/info-modal-second-view/info-modal-second-view.component';
import {PromoCodeComponent} from '../components/promo-code/promo-code.component';

@NgModule({
	declarations: [
		ArticleOptionGroupFlavorComponent,
		ArticleOptionGroupSingleComponent,
		ItemSelectableArticleComponent,
		ToOrderButtonComponent,
		OrderListComponent,
		ToggleButtonGroupComponent,
		MenuPopoverComponent,
		VenueSuggestionComponent,
		MyOrderComponent,
		HomePopoverComponent,
		ItemViewComponent,
		ArticleOptionGroupCheckboxComponent,
		ArticleOptionGroupMultipleComponent,
		BurgerBtnComponent,
		OrderContentComponent,
		PromoCodeComponent,
		PaymentMethodsDisplayComponent,
		CustomAddressModalComponent,
		TagComponent,
		TipComponent,
		LangStringPipe,
		LangObservablePipe,
		QuantitySelectorComponent,
		PreorderTypeChipComponent,
		AccountToolbarComponent,
		SlotsSelectorComponent,
		MenuModalComponent,
		NoteArticleModalComponent,
		AppRestorePasswordModalComponent,
		SelectDateFormcontrolComponent,
		CheckDeliveryRadiusModalComponent,
		MapVenueComponent,
		ToolbarLogoComponent,
		FiltersMenuComponent,
		AccordionListComponent,
		ArticleOptionGroupToggleComponent,
		CheckoutComponent,
		GetAddressModalComponent,
		FavouriteModalOnAddComponent,
		ScanQrModal,
		SelectTableModalComponent,
		FirstBoldPipe,
		FirstThinPipe,
		LastLetterThinPipe,
		FilterMapComponent,
		ShowVenueInMapComponent,
		SelectTableCheckoutComponent,
		PromoCodeComponent,
		ShowOrderItemComponent,
		SlotsModalComponent,
		SubscriptionComponent,
		AlertDeleteSubscriptionComponent,
		OrderSubscriptionItemComponent,
		AlertInfoModalComponent,
		ShowQrComponent,
		ShowSocialLinksComponent,
		InfoModalSecondViewComponent,
		VitalcodeComponent,
		VitalCodeComponent
	],
	exports: [
		ArticleOptionGroupCheckboxComponent,
		ArticleOptionGroupFlavorComponent,
		ArticleOptionGroupSingleComponent,
		ArticleOptionGroupMultipleComponent,
		ItemSelectableArticleComponent,
		ToOrderButtonComponent,
		OrderListComponent,
		ToggleButtonGroupComponent,
		HomePopoverComponent,
		VenueSuggestionComponent,
		MenuPopoverComponent,
		BurgerBtnComponent,
		MyOrderComponent,
		ItemViewComponent,
		TranslateModule,
		OrderContentComponent,
		CustomAddressModalComponent,
		LangStringPipe,
		LangObservablePipe,
		TagComponent,
		QuantitySelectorComponent,
		PreorderTypeChipComponent,
		AccountToolbarComponent,
		SlotsSelectorComponent,
		MenuModalComponent,
		NoteArticleModalComponent,
		AppRestorePasswordModalComponent,
		SelectDateFormcontrolComponent,
		CheckDeliveryRadiusModalComponent,
		ToolbarLogoComponent,
		MapVenueComponent,
		FiltersMenuComponent,
		AccordionListComponent,
		ArticleOptionGroupToggleComponent,
		CheckoutComponent,
		GetAddressModalComponent,
		ScanQrModal,
		SelectTableModalComponent,
		FirstBoldPipe,
		FirstThinPipe,
		LastLetterThinPipe,
		FilterMapComponent,
		ShowVenueInMapComponent,
		SelectTableCheckoutComponent,
		VitalcodeComponent,
		ShowOrderItemComponent,
		SlotsModalComponent,
		SubscriptionComponent,
		AlertDeleteSubscriptionComponent,
		OrderSubscriptionItemComponent,
		AlertInfoModalComponent,
		ShowQrComponent,
		ShowSocialLinksComponent,
		InfoModalSecondViewComponent,
		VitalCodeComponent
	],
	imports: [
		CommonModule,
		IonicModule,
		FormsModule,
		MatSnackBarModule,
		ReactiveFormsModule,
		ZXingScannerModule,
		TranslateModule.forChild({
			defaultLanguage: 'de',
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		}),

		RouterModule,
		MatRadioModule,
		QRCodeModule
	]
})
export class SharedModuleModule {}
